import { Dispatch, SetStateAction, useState } from 'react';
import cn from 'classnames';
import styles from './YearPicker.module.scss';
import { Button } from '../../../Button/Button';
import { Icon } from '../../../Icon/Icon';

interface YearPickerI {
  year: string;
  setYear: Dispatch<SetStateAction<string>>;
  startDate: Date;
  endDate: Date;
  setView: Dispatch<SetStateAction<'MONTH' | 'YEAR' | 'DAY'>>;
}

export const YearPicker = ({
  setYear,
  year,
  startDate,
  endDate,
  setView,
}: YearPickerI) => {
  const PER_PAGE = 12;
  const [page, setPage] = useState<number>(Math.floor(Number(year) / PER_PAGE));

  const renderYears = () => {
    const years = new Array(PER_PAGE).fill(null);

    const onYearSelect = (yearSelected: string) => {
      setYear(yearSelected);
    };

    return years.map((item, index) => {
      const yearToRender = page * PER_PAGE + index;

      const isYearAvailable =
        yearToRender >= startDate.getFullYear() &&
        yearToRender <= endDate.getFullYear();
      const key = `${year}-${index}`;
      return (
        <Button
          className={cn(
            styles.button,
            year === `${yearToRender}` && styles.active
          )}
          isDisabled={!isYearAvailable}
          onClick={() => {
            onYearSelect(yearToRender.toString());
            setView('MONTH');
          }}
          key={key}
        >{`${page * PER_PAGE + index}`}</Button>
      );
    });
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Button
          isDisabled={!(page * PER_PAGE >= startDate.getFullYear())}
          className={styles.button}
          onClick={() => setPage((p) => p - 1)}
        >
          <Icon type="left-arrow" />
        </Button>
        <div className={styles.years}>
          {`${PER_PAGE * page} - ${PER_PAGE * page + PER_PAGE - 1}`}
        </div>
        <Button
          isDisabled={
            !(page * PER_PAGE + PER_PAGE - 1 <= endDate.getFullYear())
          }
          className={styles.button}
          onClick={() => setPage((p) => p + 1)}
        >
          <Icon type="right-arrow" />
        </Button>
      </div>
      <div className={styles['years-container']}>{renderYears()}</div>
    </div>
  );
};
